import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class LayoutService {
  readonly sidebarCollapsed = signal(false);
  readonly mobileDrawerOpen = signal(false);

  toggleSidebar(): void {
    this.sidebarCollapsed.update(v => !v);
  }

  toggleMobileDrawer(): void {
    this.mobileDrawerOpen.update(v => !v);
  }

  closeMobileDrawer(): void {
    this.mobileDrawerOpen.set(false);
  }
}
